module.exports = __webpack_public_path__ + "img/social02.cd3c373e.svg";